import { Injectable } from '@angular/core';
import {
  FormArray,
  FormGroup,
  UntypedFormBuilder,
  Validators,
} from '@angular/forms';
import { getDefaultControlValue } from '@gk/gk-modules';
import { MCGRCostSctionFormArrayService } from '../costs-section/costs-secion-form.service';
import { MCGROtherSourceSettlementScopeFormGroup } from '../other-source-settlement-scope-form-array/other-source-settlement-scope-form-array.model';
import {
  MCGREstimatedWorksCostsFormGroup,
  MCGRNewRequestEstimatedWorksCostsControlName,
} from './works-estimated-costs-form.model';

@Injectable({
  providedIn: 'root',
})
export class MCGRWorksEstimatedCostsFormService {
  constructor(
    private formBuilder: UntypedFormBuilder,
    private mcgrCostSctionFormArrayService: MCGRCostSctionFormArrayService,
  ) {}

  getFormGroup(): FormGroup<MCGREstimatedWorksCostsFormGroup> {
    return this.formBuilder.group({
      [MCGRNewRequestEstimatedWorksCostsControlName.TotalAmount]:
        this.formBuilder.control(getDefaultControlValue(), [
          Validators.required,
        ]),
      [MCGRNewRequestEstimatedWorksCostsControlName.MunicipalFunds]:
        this.mcgrCostSctionFormArrayService.getFormGroup(),
      [MCGRNewRequestEstimatedWorksCostsControlName.OwnFunds]:
        this.mcgrCostSctionFormArrayService.getFormGroup(),
      [MCGRNewRequestEstimatedWorksCostsControlName.StateBudgetFunds]:
        this.mcgrCostSctionFormArrayService.getFormGroup(),
      [MCGRNewRequestEstimatedWorksCostsControlName.LocalGovernmentBudgetFunds]:
        this.mcgrCostSctionFormArrayService.getFormGroup(),
      [MCGRNewRequestEstimatedWorksCostsControlName.OtherFunds]:
        this.formBuilder.array([]) as FormArray<
          FormGroup<MCGROtherSourceSettlementScopeFormGroup>
        >,
    });
  }
}
